// src/pages/UPSCExamPattern.jsx
import React from "react";
import { motion } from "framer-motion";

const examData = [
  {
    title: "What is UPSC?",
    description:
      "The Union Public Service Commission conducts exams for top Indian administrative services like IAS, IPS, IFS, and more.",
  },
  {
    title: "Mains Exam",
    description:
      "9 descriptive papers including Essay, four General Studies papers, two Optional subject papers, and two qualifying language papers. Tests in-depth knowledge, analytical ability, and writing skills.",
  },
  {
    title: "Personal Interview",
    description:
      "Conducted by a UPSC board to assess personality, communication, ethics, judgment, and leadership qualities.",
  },
  {
    title: "Preliminary Exam",
    description:
      "The Examination shall comprise of two compulsory Papers of 200 marks each.",
    notes: [
      "Both the question papers will be of the objective type (multiple choice questions) and each will be of two hours duration.",
      "The General Studies Paper-II of the Civil Services (Preliminary) Examination will be a qualifying paper with minimum qualifying marks fixed at 33%.",
      "The question papers will be set both in Hindi and English.",
    ],
  },
];

export default function UPSCExamPattern() {
  const prelimData = examData.find((item) => item.title === "Preliminary Exam");
  const otherData = examData.filter(
    (item) => item.title !== "Preliminary Exam"
  );

  return (
    <section id="exampattern" className="w-full bg-gray-50 py-12 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-900 mb-10">
          UPSC Exam Pattern
        </h2>

        {/* Grid for Other Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {otherData.map((item, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 200 }}
              className="bg-white shadow-md rounded-2xl p-6 border-t-4 border-indigo-500 hover:shadow-lg flex flex-col"
            >
              <h3 className="text-lg font-semibold text-red-700 mb-3">
                {item.title}
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Full Width Preliminary Exam Section */}
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 150 }}
          className="bg-white shadow-md rounded-2xl p-8 border-t-4 border-indigo-500 hover:shadow-lg text-start"
        >
          <h3 className="text-2xl font-semibold text-red-700 mb-4">
            {prelimData.title}
          </h3>
          <p className="text-gray-700 text-base leading-relaxed mb-4">
            {prelimData.description}
          </p>
          <ul className="list-disc list-inside text-gray-700 text-base space-y-2">
            <h1 className="font-semibold">Note:</h1>
            {prelimData.notes.map((note, index) => (
              <li key={index}>{note}</li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
